export enum ServiceResponseStatus {
    SUCCESS = "SUCCESS",
    PARTIAL_SUCCESS = "PARTIAL_SUCCESS",
    ERROR = "ERROR",
}

export type ServiceResponse<T extends object> = Readonly<
    T & {
        serviceResponse: {
            displayMessage: string
            status?: ServiceResponseStatus
            isUserMessage?: boolean
        }
    }
>

export type ImportResultData = Readonly<{
    importResult: {
        rowChanges: {
            inserted: number
            updated: number
            deleted: number
        }
    }
}>
